import React from "react";
import { Box, Typography, Divider } from "@mui/material";

const OrderPaymentTotals = ({ payment }) => {
  const {
    subtotal = 0,
    tax = 0,
    deliveryFee = 0,
    total = 0,
    totalDiscount = 0,
  } = payment || {};

  return (
    <Box className="print-section">
      <Divider sx={{ my: 2 }} />

      <Typography align="right">Subtotal: ${subtotal.toFixed(2)}</Typography>

      {totalDiscount > 0 && (
        <Typography align="right" color="success.main">
          Discount: -${totalDiscount.toFixed(2)}
        </Typography>
      )}

      {deliveryFee > 0 && (
        <Typography align="right">
          Delivery: ${deliveryFee.toFixed(2)}
        </Typography>
      )}

      <Typography align="right">Tax: ${tax.toFixed(2)}</Typography>

      <Typography align="right" fontWeight="bold">
        Total: ${total.toFixed(2)}
      </Typography>
    </Box>
  );
};

export default OrderPaymentTotals;
